import { render, staticRenderFns } from "./IbanStripe.vue?vue&type=template&id=005bd825&scoped=true"
import script from "./IbanStripe.vue?vue&type=script&lang=js"
export * from "./IbanStripe.vue?vue&type=script&lang=js"
import style0 from "./IbanStripe.vue?vue&type=style&index=0&id=005bd825&prod&lang=scss"
import style1 from "./IbanStripe.vue?vue&type=style&index=1&id=005bd825&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005bd825",
  null
  
)

export default component.exports